import { GeneralLink } from "@fanduel/formation-react-icons";

export type CopyButtonProps = {
  dispatchFunction: () => void;
};

const CopyUrlButton = (props: CopyButtonProps) => {
  const { dispatchFunction } = props;
  return (
    <button type="button" aria-label="Copy Url" onClick={dispatchFunction}>
      <GeneralLink width={20} height={20} />
    </button>
  );
};

export default CopyUrlButton;
